import classNames from "classnames";
import NoContentCard from "../noContentCard";
import styles from "./style.module.scss";
import { useState } from "react";
import { sortJobsByKey } from "shared/utils/helper";
import { Icons } from "assets";
import Draggable from "../customDraggable";

interface CustomTableProps {
  heads: Array<CustomTableHeadType>;
  title: string;
  children: any;
  isEmpty?: boolean;
  loading: boolean;
  stickSecondCol?: boolean;
  evaluations?: any[];
  setEvaluations?: (evaluations: any[]) => void;
  setSortBy?: (sortBy: string) => void;
  setOrder?: (order: string) => void;
  sortBy?: string;
  order?: string;
}

const CustomTable = ({
  heads,
  title,
  children,
  isEmpty,
  loading,
  stickSecondCol = true,
  evaluations,
  setEvaluations,
  setSortBy,
  setOrder,
  sortBy,
  order,
}: CustomTableProps) => {
  const [sortingKeys, setSortingKeys] = useState<string[]>([]);

  const handleSorting = (key: string, revese = false) => {
    if (evaluations) {
      let keys = [...sortingKeys];
      if (keys.includes(key)) {
        keys = keys.filter((item) => item !== key);
      } else {
        keys.push(key);
      }
      setSortingKeys(keys);
      let jobs = [...evaluations];
      sortJobsByKey(jobs, key, revese);
      setEvaluations?.(jobs);
    } else {
      setSortBy?.(key);
      setOrder?.(revese ? "asc" : "desc");
    }
  };
  return (
    <Draggable disableScroll={isEmpty && !loading}>
      <table
        className="table w-full"
        style={{ minWidth: "1100px", margin: "0px" }}
      >
        <thead className={classNames(styles.stickyHeader)}>
          <tr style={{ height: "48px" }}>
            {heads?.map((item: CustomTableHeadType, inx: number) => {
              return (
                <th
                  className={classNames(
                    inx === 0 ? "ps-4" : "ps-2",
                    inx === heads?.length - 1 ? "pe-4" : "pe-2",
                    styles.tableHead,
                    inx === 0
                      ? "sticky-col first-col"
                      : inx === 1 && stickSecondCol
                      ? "sticky-col second-col"
                      : ""
                  )}
                  key={inx}
                >
                  <div
                    className={classNames(
                      "flex items-center ",
                      item?.key ? "justify-between" : "justify-center"
                    )}
                  >
                    {item?.title}
                    {item?.key ? (
                      sortingKeys.includes(item?.key) ||
                      (sortBy === item?.key && order === "desc") ? (
                        <Icons.SortAscending
                          className={classNames("cursor-pointer")}
                          onClick={() => {
                            handleSorting(item?.key, true);
                          }}
                        />
                      ) : (
                        <Icons.SortDescending
                          className={classNames("cursor-pointer")}
                          onClick={() => {
                            handleSorting(item?.key, false);
                          }}
                        />
                      )
                    ) : null}
                  </div>
                  <div></div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
      {isEmpty && !loading ? (
        <div className={classNames("my-5")}>
          <NoContentCard
            label1="No Data Found"
            //label2={`There is no data available in the "${title}" table`}
          />
        </div>
      ) : null}
    </Draggable>
  );
};

export default CustomTable;
